import RightArrowWhiteIcon from "@/components/_icons/rightArrowWhiteIcon";
import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { ROUTE_ALL, ROUTE_CONFIRMATION, ROUTE_SHOP } from "@/utils/constants";
import {
  getHardNavigationHref,
  shouldHardNavigate,
} from "@/utils/hardNavigation";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

const MerchantLinkButton = ({
  merchantColor,
  textColor,
  merchant,
  uri,
  text,
}: any) => {
  const pathName = usePathname();
  const isConfirmationScreen = pathName === ROUTE_CONFIRMATION;
  const isRetailZoneRoute = uri === ROUTE_ALL || uri === ROUTE_SHOP;
  const useHardNavigation =
    isRetailZoneRoute || (merchant && shouldHardNavigate(uri, merchant));

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!useHardNavigation) return;

    event.preventDefault();
    globalThis.location.assign(getHardNavigationHref(uri));
  };

  return (
    <Link href={uri} onClick={handleClick} className="focus-visible:ring-0">
      <div
        className={clsx(
          "text-sm text-white flex items-center w-full clover-button-primary py-2 sm:px-3 md:px-8 bg-blue-700  data-[hover]:bg-blend-darken data-[active]:bg-blend-darken",
          {
            "rounded  px-2 ": isConfirmationScreen,
            "rounded-lg px-4": !isConfirmationScreen,
          }
        )}
        style={{
          backgroundColor: merchantColor,
          color: textColor ?? "#FFFFFF",
        }}
        data-testid={
          isConfirmationScreen
            ? applyDataTestId(pom.confirmation.keepBrowsingButton)
            : undefined
        }
      >
        <span
          className={clsx("text-xs sm:text-sm text-nowrap", {
            "mr-2": isConfirmationScreen,
          })}
        >
          {text}
        </span>
        {isConfirmationScreen && (
          <RightArrowWhiteIcon stroke={textColor ?? "#FFFFFF"} />
        )}
      </div>
    </Link>
  );
};

export default MerchantLinkButton;
